import { http } from './axios'

class PermissionService {
  PermissionService () {
    console.log('const')
  }
  savePermission (data) {
    return http.post('permission/save', data)
  }
  getPermissions () {
    return http.get('permissions')
  }
  getSystemPermission () {
    return http.get('system/permission')
  }
}
export default new PermissionService()
